// extracted by mini-css-extract-plugin
export default {"inputsContainer":"styles_inputsContainer__7EB5X","margin":"styles_margin__8svEM"};